/* @ngInject */
function PostItemController ($rootScope, $timeout, ModalService, UdsModalService, PostsService, MessageService, Utils, CONSTANTS, $translate, SliderService, SegmentService, ToastService, ConfirmationModalService, CampaignService) {
  const getUpgradeCompanyPlanDialogController = () => import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller')
  const getBindCampaignDialogController = () => import('../../../core/dialogs/bind-campaign/bind-campaign-dialog.controller')
  var ctrl = this
  ctrl.flags = {
    bLoadingDetails: false
  }

  ctrl.$onChanges = function () {
    jQuery('.options-btn-dropdown').dropdown({
      showOnFocus: false,
      on: 'hover'
    })
  }

  ctrl.copyPostLink = function (post) {
    PostsService.copyPostUrlToClipboard(post.id)
      .then(() => {
        ToastService.showSuccessToast($translate.instant('copyPostLink.toast.success'))
      })
      .catch(() => {
        ToastService.showErrorToast($translate.instant('copyPostLink.toast.error'))
      })
  }

  ctrl.handleEditPostClick = function (postId, event) {
    if ($rootScope.isDesktop) {
      ctrl.preventOpenPostItemDialog(event)
      ModalService.showModal({
        templateId: 'newPost.html',
        templateUrl: '/posts/dialogs/post/post-dialog.html?$$REVISION$$',
        destroyable: true,
        closable: true,
        data: {
          _postId: postId,
          _editMode: true,
          _existingPost: true
        }
      }).then(function () {
        ctrl.onComplete()
      })
    } else {
      SliderService.setState('post-slider', 'open', {
        _postId: postId,
        _editMode: true,
        _existingPost: true
      })
    }
  }

  ctrl.handleSeeReadersClick = function (post, event) {
    SliderService.setState('readers-slider', 'open', {
      post
    })
  }

  ctrl.handleBookmarkClick = function (post, event) {
    event.stopPropagation()
    event.stopImmediatePropagation()
    if (ctrl.pricing) {
      ctrl.openUpgradeCompanyPlanDialog()
    } else {
      ctrl.pinUnpinPost(post)
    }
  }

  ctrl.openUpgradeCompanyPlanDialog = function () {
    getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
      const upgradeCompanyPlanDialog = UdsModalService.createModal({
        controller: UpgradeCompanyPlanDialogController,
        modalName: 'upgradeCompanyPlanDialog',
        data: {
          featureName: $translate.instant('billingFeatures.postsAdvancedFeatures'),
          featureSlug: 'POSTS.ADVANCED_FEATURES'
        }
      })
      upgradeCompanyPlanDialog.open()
    })
  }

  ctrl.pinUnpinPost = function (post) {
    post.loadingPinRequest = true
    const newValue = !post.isPinned

    if (newValue) {
      SegmentService.track('announcement-fix')
    }

    PostsService.updatePinnedPost({
      id: post.id,
      isPinned: newValue
    }).then(() => {
      post.isPinned = newValue
      ctrl.onPinPostChange(post)
      post.loadingPinRequest = false
    }).catch(() => {
      post.loadingPinRequest = false
      ToastService.defaultErrorToast()
    })
  }

  ctrl.handleArchivePostClick = function (postId, event) {
    ctrl.preventOpenPostItemDialog(event)

    const modalConfig = {
      title: $translate.instant('archive'),
      buttonCancelText: $translate.instant('cancel'),
      buttonConfirmText: $translate.instant('campaignEdit.archiveConfirm.confirm'),
      onConfirm: () => {
        PostsService.archivePost(postId, { isArchived: true }).then(
          function () {
            $timeout(() => {
              ToastService.defaultSuccessToast()
              ctrl.onComplete()
            }, 100)
          }
        ).catch(function (params) {
          ToastService.defaultErrorToast()
        })
      }
    }

    if (ctrl.post.campaignId) {
      modalConfig.htmlDescription = CampaignService.getArchiveHtmlDescription(ctrl.post.campaignName)
    } else {
      modalConfig.description = $translate.instant('areYouSureArchivePost')
    }

    ConfirmationModalService.createModal(modalConfig)
  }

  ctrl.handleUnarchivePostClick = function (postId, event) {
    ctrl.preventOpenPostItemDialog(event)

    MessageService.warning({
      title: $translate.instant('warning'),
      text: $translate.instant('areYouSureUnarchivePost'),
      confirmButton: $translate.instant('yesImSure'),
      cancelButton: $translate.instant('cancel'),
      press: function () {
        PostsService.archivePost(postId, { isArchived: false }).then(
          function () {
            $timeout(() => {
              ToastService.defaultSuccessToast()
              ctrl.onComplete()
            }, 100)
          }
        ).catch(function (params) {
          ToastService.defaultErrorToast()
        })
      },
      closeOnConfirm: true
    })
  }

  ctrl.getThumbnail = function () {
    return Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_THUMBNAIL_ID, [ctrl.post.thumbnailId])
  }

  ctrl.preventOpenPostItemDialog = function (event) {
    event.stopPropagation()
    event.stopImmediatePropagation()
  }

  ctrl.openBindCampaignDialog = (post) => {
    getBindCampaignDialogController().then(({ BindCampaignDialogController }) => {
      const bindCampaignDialog = UdsModalService.createModal({
        controller: BindCampaignDialogController,
        modalName: 'bindCampaignDialog',
        data: {
          currentModule: 'posts',
          assetId: post.id,
          campaignId: post.campaignId,
          campaignName: post.campaignName
        },
        onClose: (bindDetails) => {
          if (bindDetails) {
            ctrl._unbindPostFromCampaign(bindDetails)
          }
        }
      })

      bindCampaignDialog.open()
    })
  }

  ctrl._unbindPostFromCampaign = function (bindDetails) {
    PostsService.unbindPostFromCampaign(bindDetails)
      .then(() => {
        ToastService.defaultSuccessToast()
        ctrl.onComplete()
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }
}

export { PostItemController }
